import { isMobile } from './is-mobile'

/*
 * Fixed position header
 * ----------------------------------------------- */

jQuery(function($) {
  $(window).on('load scroll', function () {
    var $jsHeader = $('.js-header');
    var $menuTrigger = $(".menu-trigger");

    $jsHeader.each(function () {
      var scroll = $(window).scrollTop()

      if (scroll > 350) {
        $jsHeader.addClass('is-scrolled')
      } else {
        $jsHeader.removeClass('is-scrolled')
      }
    })
  });
});
